/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

// UTILS
import { batchActions } from 'redux-batched-actions';
import { generateRunReportParamString } from 'utils/fetchContentHelpers';
import { sendErrorMessage, displaySuccessMessage, displayErrorMessage } from 'utils/messages';
import { asyncGetUsers } from 'utils/api/account';
import { log } from 'utils/logger';
import * as reportsAPIUtil from 'utils/api/reports';

// ACTIONS
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { displayModal } from 'state/actions/modal_status';
import { receiveReportData, runReport } from 'state/actions/reportsState/selected_report_status';



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

/* ========== ~~~~~~~~~~ REPORTS STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers


export const RECEIVE_CLIENT_REPORTS_DATA = 'RECEIVE_CLIENT_REPORTS_DATA';
export const GET_CLIENT_EMAILS = 'GET_CLIENT_EMAILS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const REMOVE_REPORT_DATA = 'REMOVE_REPORT_DATA';
export const SET_LIBRARY_PRICESSING = 'SET_LIBRARY_PRICESSING';


const receiveClientReportsData = data => ({
    type: RECEIVE_CLIENT_REPORTS_DATA,
    data
});
export const updateMode = mode => ({
    type: UPDATE_MODE,
    mode
});
export const removeReportData = reportUUID => ({
    type: REMOVE_REPORT_DATA,
    reportUUID
});
const getClientEmailData = data => ({
    type: GET_CLIENT_EMAILS,
    data
});
export const setLibraryProcessing = state => ({
    type: SET_LIBRARY_PRICESSING,
    state
});

// THUNKS

export const getClientEmailsData = accountUUID => dispatch => (
    asyncGetUsers(accountUUID)
        .then(response => (
            dispatch(getClientEmailData(response.data))
        ))
        .catch(error => (
            log('no emails found') // error should fail silently, this data is optional
        ))
);
//-=-=-=-= GET CLIENT REPORTS -=-=-=-=-=-=//
const getClientReportsFail = () => dispatch => dispatch(
    batchActions([
        displayErrorMessage('There was an issue fetching your reports'),
        updateMode('library'),
        receiveClientReportsData([])]
    ));

export const getClientReportsData = accountUUID =>  dispatch => (
    reportsAPIUtil.getClientReportsData(accountUUID)
        .then(response => dispatch(receiveClientReportsData(response.data)))
        .then(() => dispatch(updateMode('library')))
        .catch(err => dispatch(getClientReportsFail()))
            // err => (sendMessage('Application Error. Code 001.')))
);

//-=-==-==-=-= GET REPORT TO EDIT -=-=--=-==-=-==//

const editReportFail = () => dispatch => dispatch(
    batchActions([
        setLibraryProcessing(false),
        displayErrorMessage('There was an issue fetching report data')]
    ));

export const editReport = reportUUID => dispatch => {
    dispatch(setLibraryProcessing(true));
    return reportsAPIUtil.getReportByUUID(reportUUID)
        .then(response => dispatch(
            // console.log({ ...response.data}),
            receiveReportData({...response.data})
        ))
        .then(() => dispatch(setLibraryProcessing(false)))
        .then(() => dispatch(updateMode('edit')))
        .then(() => dispatch(updatePageDetails('dashboard/reports/detail')))
        .then(() => dispatch(changePage('dashboard/reports/detail')))
        .catch(() => dispatch(editReportFail()))
};

//-=---=-=-=-=-=-= DELETE REPORT -=--=--=-=-=--=-==//

const deleteReportFail = () => dispatch => dispatch(
    batchActions([
        displayModal(false),
        displayErrorMessage('There was an issue deleting your report')]
    ));

export const deleteReport = (reportUUID, accountUUID) => dispatch => (
    reportsAPIUtil.deleteReportByUUID(reportUUID)
        .then(() => dispatch(removeReportData(reportUUID)))
        .then(() => dispatch(displayModal(false)))
        .then(() => dispatch(displaySuccessMessage('We have successfully deleted your report')))
        .then(() => dispatch(getClientReportsData(accountUUID)))
        .catch(() => dispatch(deleteReportFail()))
);

//-=-=-=-==-=-=-=-=-= GET AND RUN REPORT -=-=-=-=-=-=-==-//

let reportData = {};
export const getAndRunReport = reportUUID => dispatch => {
    dispatch(setLibraryProcessing(true));
    return reportsAPIUtil.getReportByUUID(reportUUID)
        .then(response => {
            reportData = response.data;
            return dispatch(receiveReportData({...response.data}))
        }).catch(()=> dispatch(editReportFail()))
        .then(() => {
            reportData.returnType = "JSON";
            dispatch(runReport(generateRunReportParamString(reportData)));
        })
        .catch(() => dispatch(setLibraryProcessing(false)))
};


